import React from 'react';
import { Sparkles } from '../../../../icons';

export const SPARK_GRAD = 'linear-gradient(135deg, #6C09F7 0%, #9333EA 50%, #F97316 100%)';

export const GRAD_TEXT: React.CSSProperties = {
  backgroundImage: SPARK_GRAD,
  WebkitBackgroundClip: 'text',
  backgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
};

export function AgentLabel({ children }: { children: React.ReactNode }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
      <span
        style={{
          width: 22,
          height: 22,
          borderRadius: 7,
          background: SPARK_GRAD,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
        }}
      >
        <Sparkles size={13} color="#fff" />
      </span>
      <span style={{ ...GRAD_TEXT, fontSize: 14, fontWeight: 500, letterSpacing: 0.4 }}>{children}</span>
    </div>
  );
}
